
import { Vue, Options } from 'vue-class-component';
import { BaseIcon } from '@/lib/components/Icon';

@Options({
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BaseIcon
  }
})
export default class ClearButton extends Vue {}
